import React from 'react';
import Button, {
  ButtonProps,
  ButtonSizes,
  ButtonTypes,
} from '@lib/components/Button/Button';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import styles from '../SelectPanel.module.scss';

type SelectPanelButtonProps = {
  buttonProps?: ButtonProps;
  computedButtonCounter?: number;
  disabled?: boolean;
  isPanelOpen: boolean;
  label?: string;
  onReset: (event: React.MouseEvent<HTMLElement>) => void;
  onTrigger: (handleToggle: (next?: boolean) => void) => void;
};

export function SelectPanelButton({
  buttonProps,
  computedButtonCounter,
  disabled,
  isPanelOpen,
  label,
  onReset,
  onTrigger,
}: SelectPanelButtonProps) {
  let rightIcon = isPanelOpen ? 'arrow_drop_up' : 'arrow_drop_down';
  let rightIconClassName;
  if (computedButtonCounter) {
    rightIcon = 'cancel';
    rightIconClassName = styles.rightIconClassName;
  }

  const mergedButtonProps: ButtonProps = {
    ...buttonProps,
    buttonText: label,
    buttonSize: ButtonSizes.large,
    buttonType: ButtonTypes.secondaryOutlined,
    counter: computedButtonCounter,
    isFocused: isPanelOpen,
    disabled: disabled ?? buttonProps?.disabled,
    rightIcon,
    rightIconClassName,
  };

  const handleTriggerClick = (
    handleToggle: (next?: boolean) => void,
    event: React.MouseEvent<HTMLElement>,
  ) => {
    if (mergedButtonProps.disabled) return;
    buttonProps?.onClick?.(event);
    onTrigger(handleToggle);
  };

  const renderTrigger = ({
    handleToggle,
  }: {
    handleToggle: (next?: boolean) => void;
  }) => (
    <div className={styles.buttonWrapper}>
      <Button
        {...mergedButtonProps}
        onClick={(event) => handleTriggerClick(handleToggle, event)}
      />
      {!!computedButtonCounter && (
        <MaterialIcon
          icon="cancel"
          className={styles.cancelButton}
          onClick={onReset}
        />
      )}
    </div>
  );

  return renderTrigger;
}
